"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeyboardFocusableElements = void 0;
var getKeyboardFocusableElements = function (node) {
    if (node === void 0) { node = document; }
    return __spreadArray([], node.querySelectorAll('a, button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'), true).filter(function (element) {
        var htmlElement = element;
        var isHiddenButton = htmlElement.nodeName.toUpperCase() === 'BUTTON' &&
            (htmlElement.clientHeight === 0 || htmlElement.clientWidth === 0);
        var isHiddenElement = htmlElement.style.display === 'none';
        return !element.hasAttribute('disabled') && !isHiddenElement && !isHiddenButton;
    });
};
exports.getKeyboardFocusableElements = getKeyboardFocusableElements;
